export default __webpack_public_path__ + "static/media/savings-targets-page.644ff1f1.svg";